import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './css/HotelMapModal.css';
import { loadGoogleMaps, getGoogleMapId } from '../../../Utils/GoogleMapsUtils';
import { SYSTEM_FAULT } from '../../../Utils/Constants/GlobalConstants';
import { ReactComponent as Close } from '../../../images/close-r.svg';
import HotelPin from '../../../images/hotel-pin.svg';

const HOTEL_ZOOM = 15;

function createPinContent() {
  const content = document.createElement('img');
  content.className = 'hmm_pin';
  content.src = HotelPin;
  content.alt = '';

  return content;
}

function HotelMapModal(props) {
  const { isVisible, handleModalClick, hotelDetails } = props;
  const mapNode = useRef(null);
  const [isError, setIsError] = useState(false);

  const lat = Number(hotelDetails.coord1);
  const lng = Number(hotelDetails.coord2);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleEscPress = (e) => {
      if (e.key === 'Escape') {
        handleModalClick();
      }
    };

    document.addEventListener('keydown', handleEscPress, false);

    return () => {
      document.removeEventListener('keydown', handleEscPress, false);
    };
  }, [isVisible, handleModalClick]);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    let marker = null;
    let isUnmounted = false;

    loadGoogleMaps()
      .then((mapsLib) => {
        if (isUnmounted || !mapNode.current) {
          return;
        }

        const position = { lat, lng };
        const map = new mapsLib.Map(mapNode.current, {
          mapId: getGoogleMapId(),
          center: position,
          zoom: HOTEL_ZOOM,
          disableDefaultUI: true,
          zoomControl: true,
          clickableIcons: false,
          gestureHandling: 'greedy',
        });

        marker = new mapsLib.AdvancedMarkerElement({
          map,
          position,
          title: hotelDetails.name,
          content: createPinContent(),
        });
      })
      .catch(() => {
        setIsError(true);
      });

    return () => {
      isUnmounted = true;

      if (marker) {
        marker.map = null;
      }
    };
  }, [isVisible, lat, lng, hotelDetails.name]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleModalClick();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="hmm_backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div className="hmm_modal">
        {isError && <div className="hmm_error gr_text_14">{SYSTEM_FAULT}</div>}
        <div className="hmm_map" ref={mapNode} />
        <button type="button" className="hmm_close" onClick={handleModalClick}>
          <Close />
        </button>
      </div>
    </div>
  );
}

HotelMapModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  handleModalClick: PropTypes.func.isRequired,
  hotelDetails: PropTypes.instanceOf(Object).isRequired,
};

export default HotelMapModal;
